import { render, staticRenderFns } from "./FullTextTemplate.vue?vue&type=template&id=8a5475f4&scoped=true&"
import script from "./FullTextTemplate.vue?vue&type=script&lang=js&"
export * from "./FullTextTemplate.vue?vue&type=script&lang=js&"
import style0 from "./FullTextTemplate.vue?vue&type=style&index=0&id=8a5475f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5475f4",
  null
  
)

export default component.exports